import {
  Flex,
  Image,
  ModalBody,
  ModalContent,
  ModalFooter,
  styled,
} from '@grupoboticario/flora-react';

export const styles = {
  ModalFooter: styled(ModalFooter, {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '$light-light',
    position: 'fixed',
    bottom: 0,
    width: '100vw',
  }),

  ModalContent: styled(ModalContent, {
    background: 'rgba(0, 0, 0, 0.5)',
    height: '100%',
  }),
  ModalBody: styled(ModalBody, {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  ModalItemWrapper: styled(Flex, {
    height: '70%',
    position: 'relative',
    bottom: '5%',
  }),

  ModalImage: styled(Image, {
    borderRadius: '$small',
    overflow: 'hidden',
    maxWidth: '100vw',
    '@tablet': {
      maxHeight: '85vh',
    },
  }),
};

export default styles;
